import { gql } from '@apollo/client';

export default gql`
  mutation requestInstitution($input: requestInstitutionInput!) {
    requestInstitution(input: $input) {
      MessageId
    }
  }
`;
